export const PAYOUT_POLICY_MODE_MAX_DAY_VS_SLOTS = 'MaxDayVsSlots';

export interface DeferredPayoutPolicySelection {
  daySetKey: string;
  peakSetKeys: string[];
}

export function buildMaxDayVsSlotsPolicy(
  selection: DeferredPayoutPolicySelection,
  uuidBySetKey: Record<string, string>,
): { mode: string; dayGoalId: string; slotGoalIds: string[] } | null {
  if (!selection || !selection.daySetKey || !selection.peakSetKeys || selection.peakSetKeys.length === 0) {
    return null;
  }
  const dayGoalId = uuidBySetKey[selection.daySetKey];
  if (!dayGoalId) {
    return null;
  }
  const slotGoalIds: string[] = [];
  for (const key of selection.peakSetKeys) {
    if (key === selection.daySetKey) {
      return null;
    }
    const id = uuidBySetKey[key];
    if (!id) {
      return null;
    }
    if (slotGoalIds.indexOf(id) === -1) {
      slotGoalIds.push(id);
    }
  }
  if (slotGoalIds.length === 0) {
    return null;
  }
  return {
    mode: PAYOUT_POLICY_MODE_MAX_DAY_VS_SLOTS,
    dayGoalId,
    slotGoalIds,
  };
}

export function deferredPayoutSelectionFromPolicy(
  policy: { dayGoalId?: string; slotGoalIds?: string[] } | null | undefined,
  uuidToSetKey: Record<string, string>,
): DeferredPayoutPolicySelection | null {
  if (!policy || !policy.dayGoalId) {
    return null;
  }
  const daySetKey = uuidToSetKey[policy.dayGoalId];
  if (!daySetKey) {
    return null;
  }
  const peakSetKeys: string[] = [];
  for (const slotId of policy.slotGoalIds || []) {
    const key = uuidToSetKey[slotId];
    if (key && key !== daySetKey && peakSetKeys.indexOf(key) === -1) {
      peakSetKeys.push(key);
    }
  }
  if (peakSetKeys.length === 0) {
    return null;
  }
  return { daySetKey, peakSetKeys };
}
